import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ChartBox from '../../Custom/ChartBox';
import SiteBlock from './SiteBlock';
import { constants } from '../../../shared/constants';

const SiteStats = ({ data }) => {
  return (
    <div>
      <ChartBox title={'Site Stats'}>
        <div id="SiteStatsContainer">
          <Row style={{ paddingLeft: '130px', paddingBottom: '15px' }}>
            <Col>
              <div>
                <strong
                  style={{ position: 'relative', right: '130px', top: '80px' }}
                >
                  Forecast Today
                </strong>
                <strong
                  style={{ position: 'relative', right: '230px', top: '150px' }}
                >
                  Reported Yesterday
                </strong>
              </div>
            </Col>
            <Col md={2}>
              <SiteBlock
                cols={1}
                color={constants.colorObjLC.site}
                title="Site"
                pvalue={`${data?.site || '0'}kWh`}
                ptype="Consumption"
                pvalue_hist={`${data?.site || '0'}kWh`}
              />
            </Col>
            <Col md={2}>
              <SiteBlock
                cols={1}
                color={constants.colorObjLC.solar}
                title="Solar"
                pvalue={`${data?.solar || '0'}kWh`}
                ptype="Generation"
                pvalue_hist={`${data?.solar || '0'}kWh`}
              />
            </Col>
            <Col md={4} cols={2}>
              <SiteBlock
                cols={2}
                color={constants.colorObjLC.grid}
                title="Grid"
                pvalue={`${data?.grid_import || '0'}kWh`}
                ptype="Import"
                pvalue_hist={`${data?.grid_import || '0'}kWh`}
                pvalueOut={`${data?.grid_export || '0'}kWh`}
                ptypeOut="Export"
                pvalue_histOut={`${data?.grid_export || '0'}kWh`}
              />
            </Col>
            <Col md={4}>
              <SiteBlock
                cols={2}
                color={constants.colorObjLC.battery}
                title="Battery"
                pvalue={`${data?.battery_charge || '0'}kWh`}
                ptype="Charge"
                pvalue_hist={`${data?.battery_charge || '0'}kWh`}
                pvalueOut={`${data?.battery_discharge || '0'}kWh`}
                ptypeOut="Discharge"
                pvalue_histOut={`${data?.battery_discharge || '0'}kWh`}
              />
            </Col>
          </Row>
        </div>
      </ChartBox>
    </div>
  );
};

export default SiteStats;
